import React from 'react';
import {
    AccountBookOutlined,
    BugOutlined,
    ClockCircleOutlined,
    CustomerServiceOutlined,
    OpenAIOutlined,
    SettingOutlined,
    UserOutlined,
} from '@ant-design/icons';
import UserManage from 'Pages/System/UserManage';
import DictManage from './Pages/System/DictManage';
import LoginSettings from './Pages/System/LoginSettings';
import {MenuManage} from 'Pages/System/MenuManage';
import RoleManage from './Pages/System/RoleManage';
import MainLayout from './Components/Layout/MainLayout';
import TenantList from 'Pages/Tenant/TenantsAll/TenantList';
import TenantDetail from './Pages/Tenant/TenantsAll/TenantDetail';
import TenantInfo from './Pages/Tenant/TenantsAll/TenantInfo';
import {Navigate, RouteObject} from 'react-router-dom';
import PlansList from 'Pages/Plans/PlansAll/PlansList';
import ServiceList from 'Pages/Service/ServiceAll/ServiceList';
import {v4} from 'uuid';
import TenantService from './Pages/Tenant/TenantsAll/TenantService';
import Website from 'Pages/Reptile/Website';
import WebTag from 'Pages/Reptile/WebTag';
import PageMethod from './Pages/DataSynchronization/PageMethod';
import PageTask from './Pages/DataSynchronization/PageTask';
import PagePlan from 'Pages/DataSynchronization/PagePlan';
import Platform from 'Pages/Reptile/Platform';
import Account from 'Pages/Reptile/Account';
import Article from 'Pages/Reptile/Article';
import RagFlow from 'Pages/Ai/RagFlow';
import Agent from './Pages/Ai/Agent';
import DataSet from 'Pages/Ai/DataSet';
import Mcp from 'Pages/Ai/Mcp';

export interface AppMenuHandle {
    label?: string;
    icon?: React.ReactNode;
    auth?: string;
    showNav?: boolean;
    isLast?: boolean;
}

interface Handle {
    children?: AppMenuItem[];
    handle?: AppMenuHandle;
}

export type AppMenuItem = RouteObject & Handle;

export const MainMenu: AppMenuItem[] = [
    {
        element: <MainLayout />,
        children: [
            {
                index: true,
                element: <Navigate replace to="/tenant/list" />,
            },
            {
                path: 'tenant',
                handle: {
                    icon: <UserOutlined />,
                    label: '租户管理',
                    showNav: true,
                    key: v4(),
                },
                children: [
                    {
                        path: '',
                        element: <Navigate replace to="list" />,
                    },
                    {
                        handle: {
                            label: '全部租户',
                            showNav: true,
                            isLast: true,
                            key: v4(),
                        },
                        path: 'list',
                        children: [
                            {
                                index: true,
                                element: <TenantList />,
                            },
                            {
                                handle: {
                                    showNav: false,
                                    label: '租户详情',
                                    key: v4(),
                                },
                                path: 'detail/:id',
                                element: <TenantDetail />,
                            },
                            {
                                handle: {
                                    showNav: false,
                                    label: '机构信息',
                                    key: v4(),
                                },
                                path: 'info',
                                element: <TenantInfo />,
                            },
                            {
                                handle: {
                                    showNav: false,
                                    label: '机构信息',
                                    key: v4(),
                                },
                                path: 'info/:id',
                                element: <TenantInfo />,
                            },
                            {
                                handle: {
                                    showNav: false,
                                    label: '服务列表',
                                    key: v4(),
                                },
                                path: 'service/:id',
                                element: <TenantService />,
                            },
                        ],
                    },
                ],
            },
            {
                path: 'plans',
                handle: {
                    icon: <AccountBookOutlined />,
                    label: '销售方案',
                    showNav: true,
                    key: v4(),
                },
                children: [
                    {
                        path: '',
                        element: <Navigate replace to="list" />,
                    },
                    {
                        handle: {
                            label: '全部方案',
                            showNav: true,
                            isLast: true,
                            key: v4(),
                        },
                        path: 'list',
                        children: [
                            {
                                index: true,
                                element: <PlansList />,
                            },
                        ],
                    },
                ],
            },
            {
                path: 'ai',
                handle: {
                    icon: <OpenAIOutlined />,
                    label: 'Ai设置',
                    showNav: true,
                    key: v4(),
                },
                children: [
                    {
                        path: '',
                        element: <Navigate replace to="ragFlow" />,
                    },
                    {
                        handle: {
                            label: '系统配置',
                            showNav: true,
                            isLast: true,
                            key: v4(),
                        },
                        path: 'ragFlow',
                        children: [
                            {
                                index: true,
                                element: <RagFlow />,
                            },
                        ],
                    },
                    {
                        handle: {
                            label: '智能体',
                            showNav: true,
                            isLast: true,
                            key: v4(),
                        },
                        path: 'agent',
                        children: [
                            {
                                index: true,
                                element: <Agent />,
                            },
                        ],
                    },
                    {
                        handle: {
                            label: '数据集',
                            showNav: true,
                            isLast: true,
                            key: v4(),
                        },
                        path: 'dataSet',
                        children: [
                            {
                                index: true,
                                element: <DataSet />,
                            },
                        ],
                    },
                    {
                        handle: {
                            label: 'Mcp',
                            showNav: true,
                            isLast: true,
                            key: v4(),
                        },
                        path: 'mcp',
                        children: [
                            {
                                index: true,
                                element: <Mcp />,
                            },
                        ],
                    },
                ],
            },
            {
                path: 'reptile',
                handle: {
                    icon: <BugOutlined />,
                    label: '大数据管理',
                    showNav: true,
                    key: v4(),
                },
                children: [
                    {
                        path: '',
                        element: <Navigate replace to="website" />,
                    },
                    {
                        handle: {
                            label: '网站管理',
                            showNav: true,
                            isLast: true,
                            key: v4(),
                        },
                        path: 'website',
                        children: [
                            {
                                index: true,
                                element: <Website />,
                            },
                        ],
                    },
                    {
                        handle: {
                            label: '标签管理',
                            showNav: true,
                            isLast: true,
                            key: v4(),
                        },
                        path: 'tag',
                        children: [
                            {
                                index: true,
                                element: <WebTag />,
                            },
                        ],
                    },
                    {
                        handle: {
                            label: '微信平台账号',
                            showNav: true,
                            isLast: true,
                            key: v4(),
                        },
                        path: 'platform',
                        children: [
                            {
                                index: true,
                                element: <Platform />,
                            },
                        ],
                    },
                    {
                        handle: {
                            label: '公众号关注',
                            showNav: true,
                            isLast: true,
                            key: v4(),
                        },
                        path: 'account',
                        children: [
                            {
                                index: true,
                                element: <Account />,
                            },
                        ],
                    },
                    {
                        handle: {
                            label: '公众号文章',
                            showNav: true,
                            isLast: true,
                            key: v4(),
                        },
                        path: 'article',
                        children: [
                            {
                                index: true,
                                element: <Article />,
                            },
                        ],
                    },
                ],
            },
            {
                path: 'service',
                handle: {
                    icon: <CustomerServiceOutlined />,
                    label: '服务管理',
                    showNav: true,
                    key: v4(),
                },
                children: [
                    {
                        path: '',
                        element: <Navigate replace to="list" />,
                    },
                    {
                        handle: {
                            label: '全部服务',
                            showNav: true,
                            isLast: true,
                            key: v4(),
                        },
                        path: 'list',
                        children: [
                            {
                                index: true,
                                element: <ServiceList />,
                            },
                        ],
                    },
                ],
            },
            {
                path: 'system',
                handle: {
                    icon: <SettingOutlined />,
                    auth: 'grouping_sytm_management',
                    label: '系统管理',
                    key: v4(),
                    showNav: true,
                },
                children: [
                    {
                        path: 'user',
                        element: <UserManage />,
                        handle: {
                            showNav: true,
                            label: '用户管理',
                            key: v4(),
                            auth: 'menu_user_management',
                        },
                    },
                    {
                        path: 'dict',
                        element: <DictManage />,
                        handle: {
                            showNav: true,
                            label: '数据字典',
                            key: v4(),
                            auth: 'menu_data_dictionary',
                        },
                    },
                    {
                        path: 'loginSettings/*',
                        element: <LoginSettings />,
                        handle: {
                            showNav: true,
                            label: '登录设置',
                            key: v4(),
                            auth: 'menu_lgi_seting',
                        },
                    },
                    {
                        path: 'menus',
                        element: <MenuManage />,
                        handle: {
                            showNav: true,
                            label: '菜单管理',
                            key: v4(),
                            auth: 'menu_menu_settings',
                        },
                    },
                    {
                        path: 'roleSettings',
                        element: <RoleManage />,
                        handle: {
                            showNav: true,
                            label: '角色管理',
                            key: v4(),
                            auth: 'menu_roler_management',
                        },
                    },
                ],
            },
            {
                path: 'task',
                handle: {
                    icon: <ClockCircleOutlined />,
                    auth: 'grouping_tasks',
                    label: '定时任务',
                    key: v4(),
                    showNav: true,
                },
                children: [
                    {
                        path: 'sync_business',
                        element: <PageMethod />,
                        handle: {
                            showNav: true,
                            label: '业务方法',
                            key: v4(),
                            auth: 'menu_sync_business',
                        },
                    },
                    {
                        path: 'sync_job',
                        element: <PageTask />,
                        handle: {
                            showNav: true,
                            label: '调度任务',
                            key: v4(),
                            auth: 'menu_sync_job',
                        },
                    },
                    {
                        path: 'sync_plan',
                        element: <PagePlan />,
                        handle: {
                            showNav: true,
                            label: '调度计划',
                            key: v4(),
                            auth: 'menu_sync_plan',
                        },
                    },
                ],
            },
        ],
    },
];
